import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ArrowRight, Code2, Gamepad2, Sparkles } from 'lucide-react';
import Home from './Home';
import './App.css';

const businessSites = [
  {
    label: '6uo Games',
    detail: 'Company website',
    href: 'https://6uogames.com',
    icon: Gamepad2,
  },
  {
    label: '6uo Foundation',
    detail: 'Official whitepaper',
    href: 'https://6uo.foundation',
    icon: Code2,
  },
  {
    label: '6uo.io',
    detail: 'Studio home',
    href: 'https://6uo.io',
    icon: Sparkles,
  },
];

const BusinessWebsitesPage = () => (
  <main className="min-h-screen overflow-hidden bg-[#09111b] text-white">
    <section className="relative flex min-h-screen items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_10%,rgba(0,240,255,0.16),transparent_34%),linear-gradient(135deg,rgba(12,24,38,0.95),rgba(5,10,16,1)_62%)]" />
      <div className="relative z-10 w-full max-w-[900px]">
        <a
          href="/"
          className="mb-8 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.2em] text-cyber-gray transition hover:text-neon-blue"
        >
          Back to card
        </a>

        <div className="rounded-[28px] border border-white/12 bg-[#0d1824]/92 p-6 shadow-[0_30px_120px_rgba(0,0,0,0.55),0_0_42px_rgba(0,240,255,0.18)] backdrop-blur-xl sm:p-8 md:p-10">
          <p className="text-sm font-semibold uppercase tracking-[0.24em] text-neon-blue">
            6uo
          </p>
          <h1 className="mt-3 font-display text-4xl font-black tracking-normal text-white sm:text-5xl md:text-6xl">
            Business Websites
          </h1>
          <p className="mt-4 max-w-xl text-base leading-7 text-cyber-gray sm:text-lg">
            Company links moved off the back of the personal card.
          </p>

          <div className="mt-8 grid gap-3 md:grid-cols-3">
            {businessSites.map(({ label, detail, href, icon: Icon }) => (
              <a
                key={href}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex min-h-[170px] flex-col justify-between rounded-2xl border border-white/10 bg-white/[0.045] p-5 transition hover:border-neon-blue/45 hover:bg-neon-blue/10 focus:outline-none focus:ring-2 focus:ring-neon-blue/70"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-white/8 text-neon-blue transition group-hover:bg-neon-blue group-hover:text-[#031018]">
                  <Icon className="h-5 w-5" />
                </span>
                <span>
                  <span className="block text-lg font-bold text-white">{label}</span>
                  <span className="mt-1 block text-sm text-cyber-gray">{detail}</span>
                </span>
                <span className="flex items-center gap-2 text-sm font-semibold text-neon-blue">
                  Open
                  <ArrowRight className="h-4 w-4 transition group-hover:translate-x-1" />
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  </main>
);

function App() {
  return (
    <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/6uo" element={<BusinessWebsitesPage />} />
      </Routes>
    </Router>
  );
}

export default App;
